import companyLogo from './assets/MPS_Logo.png';
import logo from './assets/Truck_logo.png';
import whiteLogo from './assets/Truck_logo_white.png';
import mainImage from './assets/login-image.png';

export const APPLICATION_NAME = 'MOST';

export const PRODUCT_LOGO = logo;
export const NAVIGATION_LOGO = whiteLogo;
export const SPINNER_LOGO = PRODUCT_LOGO;
export const COMPANY_LOGO = companyLogo;

export const PRODUCT_INFO = {
  layout: 'landscape',
  logo: PRODUCT_LOGO,
  productDescription: 'MPS Order Search Tool',
  mainImage,
  companyLogo: COMPANY_LOGO,
} as const;

export const CSRF_COOKIE_NAME = 'csrftoken';

export const ENVIRONMENTS = {
  PRODUCTION: 'prd',
  STAGING: 'stg',
  DEVELOPMENT: 'dev',
};

export const GOOGLE_ANALYTICS_CODES = {
  [ENVIRONMENTS.PRODUCTION]: 'G-BSQ4NR4L3M',
  [ENVIRONMENTS.STAGING]: 'G-WL8RMVHDB5',
  [ENVIRONMENTS.DEVELOPMENT]: '',
};

export const SENTRY_TRACKING_URLS = {
  [ENVIRONMENTS.PRODUCTION]:
    'https://7c18380f2923673f4faa42d59681ed89@o46592.ingest.us.sentry.io/4510103629791232',
  [ENVIRONMENTS.STAGING]:
    'https://7c18380f2923673f4faa42d59681ed89@o46592.ingest.us.sentry.io/4510103629791232',
  [ENVIRONMENTS.DEVELOPMENT]: '',
};

export const API_ENDPOINTS = {
  CONFIGS: 'configs/',
  CUSTOMERS_BILL_NAMES: 'customers/bill-names/',
  CUSTOMERS_SHIP_NAMES: 'customers/ship-names/',
  ORDERS: 'orders/',
  ORDERS_DETAILS: 'orders/details/',
  ORDERS_DETAILS_COUNTS: 'orders/details/counts/',
  ORDERS_DETAILS_EXPORT: 'orders/details/export/',
};

export const WIDGET_ID = 44000004889;

export const ROUTES = {
  HOME_PAGE: '/',
  CONTACTS_PAGE: '/contacts',
  HELP_PAGE: '/help',
  LOGIN_PAGE: '/login',
};

export const NAVIGATION_LINKS = [
  {name: 'Home', path: ROUTES.HOME_PAGE},
  {
    name: 'Contacts',
    path: ROUTES.CONTACTS_PAGE,
  },
  {name: 'Help', path: ROUTES.HELP_PAGE},
];

export const NOTIFICATIONS_KIND = {
  ALERT: 'alert',
  FAILURE: 'failure',
  INVALID: 'invalid',
  SUCCESS: 'success',
  CARRIER_UPDATE_DELAY: 'carrier_update_delay',
} as const;

export const URL_PARAMS = {
  OFFSET: 'offset',
  LIMIT: 'limit',
  ORDERING: 'ordering',
} as const;

export const CONFIGS_FIELDS = {
  AUTHORIZATION_FIELDS: 'authorization_fields',
  CARRIER_LOGOS: 'carrier_logos',
  FIELDS_ORDER_DETAIL: 'fields_order_items',
  FIELDS_ORDERS: 'fields_orders',
  ORDER_DETAIL_FIELDS: 'order_item_fields',
  ORDER_FIELDS: 'order_fields',
  PO_STATUSES: 'po_statuses',
  PROFILE_DEFAULTS: 'profile_defaults',
  SHIPPING_STATUSES: 'shipping_statuses',
} as const;
